import React from "react";

import CustomerLayout from "../layouts/CustomerLayout";
import Card from "../components/ui/Card";
import Button from "../components/ui/Button";
import Badge from "../components/ui/Badge";
import PageHeader from "../components/ui/PageHeader";

export default function UpgradePage() {
  const params = new URLSearchParams(window.location.search);
  const feature = params.get("feature") || "This feature";

  return (
    <CustomerLayout>
      <main style={{ maxWidth: 1000, margin: "0 auto" }}>
        <PageHeader
          title={`${feature} is coming soon`}
          subtitle="This capability is part of Ecovanta's AI Sustainability Intelligence roadmap."
        />

        <Card
          title="Feature not available yet"
          subtitle="We're preparing this module for a future release."
        >
          <div style={{ display: "grid", gap: 16 }}>
            <Badge tone="primary">Coming Soon</Badge>

            <p>
              {feature} will help sustainability teams move from reporting to
              AI-powered insights, recommendations, and advisory workflows.
            </p>

            <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
              <Button onClick={() => (window.location.href = "/app/dashboard")}>
                Back to Dashboard
              </Button>

              <Button
                variant="secondary"
                onClick={() => (window.location.href = "/admin/advisory-documents")}
              >
                Open Document Center
              </Button>
            </div>
          </div>
        </Card>
      </main>
    </CustomerLayout>
  );
}